import { render, staticRenderFns } from "./design_goods.vue?vue&type=template&id=e18211ae&scoped=true"
import script from "./design_goods.vue?vue&type=script&lang=js"
export * from "./design_goods.vue?vue&type=script&lang=js"
import style0 from "./design_goods.vue?vue&type=style&index=0&id=e18211ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18211ae",
  null
  
)

export default component.exports